enum EUserName {
    ADMIN = 'guidetti_api_admin',
    USER = 'guidetti_api_user',
}

export default EUserName;
